import { getNow } from './now';
import { retryOnException } from './retry-operation';

export enum PerformanceMetric {
  FeatureFlagClient = 'featureFlagClient',
  AvailableProductsService = 'availableProductsService',
  CollaborationGraphService = 'collaborationGraphService',
  CollaborationGraphObjectService = 'collaborationGraphObjectService',
  IdentityMeService = 'identityMeService',
  JoinableSitesService = 'joinableSitesService',
  OrgService = 'orgService',
  ProductConfigurationService = 'productConfigurationService',
  ProductRecommendationsService = 'productRecommendationsService',
  GrowthProductRecommendationsService = 'growthProductRecommendationsService',
  WorklensActivitiesService = 'worklensActivitiesService',
}

const measurePerformance = async <T>(metricName: string, requestFn: () => Promise<T>, retryMS?: number[]) => {
  const start = getNow();
  let duration = 0;
  let attemptNumber = 0;
  try {
    const onAttempt = () => (attemptNumber += 1);
    const response = await (async () => {
      if (retryMS) {
        return retryOnException(
          () => {
            onAttempt();
            return requestFn();
          },
          { intervalsMS: retryMS },
        );
      }
      onAttempt();
      return requestFn();
    })();
    duration = getNow() - start;
    return response;
  } catch (error) {
    duration = getNow() - start;
    throw error;
  } finally {
    // TODO: replace this with UFO
    // metricsClient.client.metric.submit({
    //   name: 'COMPONENT_REQUEST_TIMING',
    //   component: metricName,
    //   value: duration,
    //   page: '/',
    // });
  }
};

export default measurePerformance;
